/**
 * Content Module
 * Expandable text and card about brand functionality
 */

export function initMoreContent() {
  function initExpandableText(selector, maxLines = 4) {
    const cardElements = document.querySelectorAll(selector);

    if (cardElements.length === 0) {
      console.error("Card element tidak ditemukan");
      return;
    }

    cardElements.forEach((cardElement, index) => {
      const textElement = cardElement.querySelector(".cardStory__content");
      const btnElement = cardElement.querySelector(".cardStory__action .btn");

      if (!textElement || !btnElement) {
        console.error(
          `Content atau button element tidak ditemukan pada card index ${index}`
        );
        return;
      }

      function getLineCount(element) {
        const clone = element.cloneNode(true);
        clone.style.height = "auto";
        clone.style.maxHeight = "none";
        clone.style.webkitLineClamp = "none";
        clone.style.display = "block";
        clone.style.visibility = "hidden";
        clone.style.position = "absolute";
        clone.style.width = element.offsetWidth + "px";

        element.parentNode.appendChild(clone);
        const fullHeight = clone.scrollHeight;
        element.parentNode.removeChild(clone);

        return Math.ceil(fullHeight / 32);
      }

      function toggleText() {
        if (cardElement.classList.contains("show")) {
          cardElement.classList.remove("show");
        } else {
          cardElement.classList.add("show");
        }
      }

      function init() {
        cardElement.classList.remove("noMore", "addMore", "show");
        const lineCount = getLineCount(textElement);

        if (lineCount <= maxLines) {
          cardElement.classList.add("noMore");
        } else {
          cardElement.classList.add("addMore");
        }
      }

      const clickHandler = (e) => {
        e.preventDefault();
        toggleText();
      };

      btnElement.removeEventListener("click", clickHandler);
      btnElement.addEventListener("click", clickHandler);

      const resizeHandler = () => init();
      window.removeEventListener("resize", resizeHandler);
      window.addEventListener("resize", resizeHandler);

      init();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initExpandableText(".cardStory", 4);
    });
  } else {
    initExpandableText(".cardStory", 4);
  }
}

export function initCardAboutBrand() {
  const cardAboutBrands = document.querySelectorAll(".cardAboutBrand");

  cardAboutBrands.forEach((card) => {
    const maxItems = parseInt(card.dataset.max) || 10;
    const gridItems = card.querySelectorAll(".cardAboutBrand__grid5-list");
    const actionBtn = card.querySelector(".cardAboutBrand__action");

    if (gridItems.length > maxItems) {
      card.classList.add("with-action");
      gridItems.forEach((item, index) => {
        if (index >= maxItems) {
          item.classList.add("hide-item");
        }
      });

      actionBtn.addEventListener("click", () => {
        if (card.classList.contains("expanded")) {
          gridItems.forEach((item, index) => {
            if (index >= maxItems) {
              item.classList.add("hide-item");
            }
          });
          card.classList.remove("expanded");
        } else {
          gridItems.forEach((item) => {
            item.classList.remove("hide-item");
          });
          card.classList.add("expanded");
        }
      });
    } else {
      actionBtn.classList.add("hide");
    }
  });
}

export function initTrustedLoadMore() {
  const grid = document.querySelector(".grid-trusted");
  const btnWrap = document.querySelector(".section-trusted-by .btn-wrap");
  const btn = document.querySelector(".section-trusted-by .btn-load-more");
  const btnLabel = btn ? btn.querySelector("span") : null;

  if (!grid || !btn || !btnWrap) return;

  const items = Array.from(grid.querySelectorAll(".grid-item"));
  if (items.length === 0) return;

  const isMobile = () => window.innerWidth < 768;
  const getItemsPerRow = () => (isMobile() ? 2 : 6);
  const getInitialRows = () => 4;
  const getLoadMoreRows = () => (isMobile() ? 2 : 4);

  const labelMore = "Lihat lebih banyak";
  const labelLess = "Tampilkan lebih sedikit";

  let visibleCount = 0;
  let isExpanded = false;

  function getDefaultVisible() {
    return getItemsPerRow() * getInitialRows();
  }

  function updateVisibility() {
    const perRow = getItemsPerRow();
    const initialVisible = perRow * getInitialRows();
    const total = items.length;

    // If total is already within initial visible, show all and hide button
    if (total <= initialVisible) {
      items.forEach((item) => item.classList.remove("grid-item-hidden"));
      btnWrap.classList.add("is-hidden");
      return;
    }

    btnWrap.classList.remove("is-hidden");

    const targetVisible = isExpanded
      ? total
      : Math.min(visibleCount || initialVisible, total);

    items.forEach((item, index) => {
      if (index < targetVisible) {
        item.classList.remove("grid-item-hidden");
      } else {
        item.classList.add("grid-item-hidden");
      }
    });

    // Update button label
    if (btnLabel) {
      btnLabel.textContent = targetVisible >= total ? labelLess : labelMore;
    }
  }

  btn.addEventListener("click", () => {
    const perRow = getItemsPerRow();
    const increment = perRow * getLoadMoreRows();
    const defaultVisible = perRow * getInitialRows();

    if (isExpanded) {
      // Collapse back to default
      isExpanded = false;
      visibleCount = defaultVisible;
    } else {
      visibleCount = visibleCount || defaultVisible;

      if (isMobile()) {
        // Mobile: open all at once
        isExpanded = true;
        visibleCount = items.length;
      } else {
        // Desktop: load more in increments
        visibleCount += increment;

        if (visibleCount >= items.length) {
          isExpanded = true;
          visibleCount = items.length;
        }
      }
    }

    updateVisibility();
  });

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      isExpanded = false;
      visibleCount = 0;
      updateVisibility();
    }, 150);
  });

  updateVisibility();
}
